import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import TmCalendar from '../../../icons/TmCalendar';

interface DatePickerFormControlProps {
    name: string;
    label: string;
    style?: React.CSSProperties;
    format?: string;
    required?: boolean;
    disabled?: boolean;
    views?: ('year' | 'month' | 'day')[];
    onChangeCustom?: (value: dayjs.Dayjs | null) => dayjs.Dayjs | null;
}

export const DatePickerFormControl = ({ name, label, style, format, required = false, disabled = false, views, onChangeCustom }: DatePickerFormControlProps) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            rules={required ? { required: 'Поле обязательно для заполнения' } : {}}
            render={({ field: { onChange, ref, ...field }, fieldState: { error } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
                    <DatePicker
                        format={format}
                        label={label}
                        views={views}
                        slots={{
                            openPickerIcon: TmCalendar,
                          }}
                        value={field.value ? dayjs(field.value) : null}
                        onChange={(newValue) => {
                            if (newValue?.isValid()) {
                                const processedValue = onChangeCustom ? onChangeCustom(newValue) : newValue;
                                onChange(processedValue ? processedValue.toISOString() : null);
                            } else if (newValue === null) {
                                onChange(null);
                            }
                        }}
                        slotProps={{
                            textField: {
                                size: 'small',
                                style: { ...style },
                                error: !!error,
                                helperText: error ? error.message : null,
                                required: required,
                                disabled: disabled,
                                InputLabelProps: {
                                    sx: {
                                        whiteSpace: 'nowrap',
                                        overflow: 'visible',
                                        textOverflow: 'clip',
                                        maxWidth: 'none'
                                    }
                                }
                            }
                        }}
                    />
                </LocalizationProvider>
            )}
        />
    );
};